"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMedicalName = void 0;
var formatMedicalName = function (str) {
    var _a;
    return (_a = str === null || str === void 0 ? void 0 : str.toUpperCase().replace('_', ' ').replace(/\b(?!(MD|OD|DPT|PT|DDS|LCSWA|PA-C|DPM|PA|LCSW|DC|III|II|DMD|PHD|FNP|BC|C|OTL|CRNP|NP|LP|DO|OT|MSW|BCBA|CRNA|LPC|LSW|LCAS|LPC|XR|IR|MG|MPH)\b)\w+/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    })) === null || _a === void 0 ? void 0 : _a.replace(' MG', 'mg');
};
exports.formatMedicalName = formatMedicalName;
